<div class="modal-content">
  <div class="modal-header">
    <div class="modal-header-center">
      <h4 class="modal-title">Add Client</h4>
    </div>
    <div class="modal-header-right">
      <button
        type="button"
        class="close"
        (click)="close()"
        data-dismiss="modal"
        aria-label="Close"
      >
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
  <form name="addClient" [formGroup]="form">
    <div class="modal-body">
      <app-input
        *ngIf="isProductionEnv"
        controlName="Id"
        [form]="form"
        type="text"
        label="Client ID"
      ></app-input>
      <app-input
        *ngIf="!isProductionEnv"
        controlName="ClientId"
        [form]="form"
        type="text"
        label="Client ID"
      ></app-input>
      <app-input
        controlName="Name"
        [form]="form"
        type="text"
        label="Name"
      ></app-input>
      <div *ngIf="clientExists" class="info-box error-box ng-star-inserted">
        <span class="text-danger">Client already exists </span>
      </div>
      <app-input
        controlName="RefreshTokenLifeTime"
        [form]="form"
        type="number"
        label="Refresh Token Life Time (in seconds)"
        appNumberOnly
      ></app-input>
      <app-input
        controlName="AllowedOrigin"
        [form]="form"
        type="text"
        label="Allowed Origin"
      ></app-input>
      <app-textarea
        controlName="Domains"
        [form]="form"
        label="Domains (provide complete domain urls)"
      ></app-textarea>
      <app-checkbox
        [form]="form"
        label="Active"
        controlName="Active"
      ></app-checkbox>
    </div>
    <div class="modal-footer modal-footer-custom-new01">
      <div class="modal-footer-bottom">
        <app-modal-action-btns
          [form]="form"
          [disabled]="form.invalid || clientExists"
          (onReject)="close()"
          (onConfirm)="submit()"
          [useFormSubmit]="false"
        ></app-modal-action-btns>
      </div>
    </div>
  </form>
</div>
